
import * as verilogGrammar from "../../../src/Renderer/VerilogComponent/VerilogGrammar.js";
import nearley from "nearley";
import { parseFromFile, fix } from "../../../src/Renderer/VerilogComponent/parser.js";
import { head, tail, reverse, exists as exists_1, isEmpty as isEmpty_1, fold, filter as filter_1, contains, concat, map as map_2, append, empty, collect, length as length_1, map2, ofSeq, ofArray, singleton, item as item_2, findIndexBack, tryFind } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { MapModule_KeysL, StringModule_Concat, StringModule_Length } from "../Common/EEExtensions.js";
import { VerilogInput_$reflection, ParserOutput_$reflection, PortAssignmentError, ExtraErrorInfo, ReplaceType, ErrorInfo } from "./VerilogTypes.js";
import { List_distinct, List_countBy, except, countBy, List_except, distinct } from "../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { Exception, safeHash, compare, int32ToString, equals, comparePrimitives, stringHash } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { containsKey, empty as empty_1, add, fold as fold_2, find, ofSeq as ofSeq_1, filter, toList, tryFind as tryFind_1, ofList } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { parse } from "../fable_modules/fable-library-js.5.13.0/Int32.js";
import { value as value_2, defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { map as map_3, toList as toList_1, isEmpty } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { toFail, printf, toText } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { evalExpr, convertItem, getAssignmentsWithLocations, getPrimaryLocation, AssignDU, convertAssignment, convertStatement, getAssignments$0027, getPrimaryRange, DeclarationDU, convertModule, evalExprWithParams, getAlwaysBlocks, AlwaysDU, getAllExpressions$0027, ASTNode, foldAST, getPrimaryName } from "./VerilogAST.js";
import { getPrimaryWidth, getWireSizeMap, lhsName as lhsName_2, getLHSWidth, getWidthOfExpr, getCondAndCaseExpressions, checkExpr, checkPrimariesWidths, findCloseVariable, estimateExprCost, estimateAssignmentCost, getForStatementsWithLoc, lhsLocation, getDeclarations, primariesUsedInAssignment, getModuleInstantiationStatements, getModuleInstantiationInputPrimaries } from "./ErrorCheckHelpers.js";
import { difference, ofArray as ofArray_1, contains as contains_1, ofList as ofList_1 } from "../fable_modules/fable-library-js.5.13.0/Set.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.13.0/Range.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.5.13.0/Result.js";
import { map as map_4, append as append_1, fold as fold_1 } from "../fable_modules/fable-library-js.5.13.0/Array.js";
import { checkProceduralAssignments, checkVariablesDrivenSimultaneously, checkVariablesAlwaysAssigned, checkArrayStatements, checkCasesStatements, checkExpressions, checkClk, checkClkNames, cycleCheck, checkVariablesUsed, checkAlwaysCombRHS, checkModuleInstantiations } from "./ErrorCheckProcedural.js";
import { pathJoin, tryReadFileSync } from "../Interface/FilesIO.js";
import { SimpleJson_tryParse } from "../Common/SimpleJson/SimpleJson.js";
import { Convert_fromJson } from "../Common/SimpleJson/Json.Converter.js";
import { createTypeInfo } from "../Common/SimpleJson/TypeInfo.Converter.js";




function getFileInProject(name, project) {
    return tryFind((comp) => (comp.Name.toLocaleUpperCase() === name.toLocaleUpperCase()), project.LoadedComponents);
}

function isFileInProject(name, project) {
    const _arg = getFileInProject(name, project);
    if (_arg != null) {
        return true;
    }
    else {
        return false;
    }
}

/**
 * Helper function to create an ErrorInfo-type Error Message
 * given the location, the variable name, and the message
 */
export function createErrorMessage(newLinesLocations, currLocation, message, extraMessages, name) {
    const prevIndex = findIndexBack((x) => (x <= currLocation), newLinesLocations) | 0;
    return singleton(new ErrorInfo(prevIndex + 1, (currLocation - item_2(prevIndex, newLinesLocations)) + 1, StringModule_Length(name), message, extraMessages));
}

/**
 * Checks whether all ports given in the beginning of the module are defined as input/output
 * Also if all ports have distinct names
 */
export function portCheck(ast, linesLocations, errorList) {
    const portList = ofArray(ast.Module.PortList);
    const distinctPortList = ofSeq(distinct(portList, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }));
    const locationMap = ofList(map2((p, i) => [p, parse(i, 511, false, 32)], portList, ofArray(ast.Module.Locations)), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    });
    const locationOf = (name) => (defaultArg(tryFind_1(name, locationMap), 0) | 0);
    if (ast.Module.Type === "module_new") {
        return errorList;
    }
    else {
        const matchValue_1 = length_1(portList) === length_1(distinctPortList);
        if (matchValue_1) {
            const diff = List_except(collect((x_5) => {
                const matchValue_2 = x_5.IODecl == null;
                if (matchValue_2) {
                    return empty();
                }
                else {
                    const matchValue_3 = x_5.IODecl;
                    if (matchValue_3 == null) {
                        return empty();
                    }
                    else {
                        return collect((x_6) => singleton(x_6.Name), ofArray(matchValue_3.Variables));
                    }
                }
            }, ofArray(ast.Module.ModuleItems.ItemList)), portList, {
                Equals: (x_7, y_4) => (x_7 === y_4),
                GetHashCode: (x_7) => (stringHash(x_7) | 0),
            });
            const matchValue_4 = isEmpty(diff);
            if (matchValue_4) {
                return errorList;
            }
            else {
                return append(errorList, collect((name_4) => {
                    const message_1 = toText(printf("Port \'%s\' is not declared either as input or output"))(name_4);
                    const extraMessages_1 = [new ExtraErrorInfo(toText(printf("Port \'%s\' must be declared as input or output"))(name_4), false, ReplaceType.NoReplace), new ExtraErrorInfo(toText(printf("input bit %s;|output bit %s;"))(name_4)(name_4), true, ReplaceType.IODeclaration)];
                    return createErrorMessage(linesLocations, locationOf(name_4), message_1, extraMessages_1, name_4);
                }, diff));
            }
        }
        else {
            return append(errorList, collect((name_3) => {
                const extraMessages = [new ExtraErrorInfo(toText(printf("Name \'%s\' has already been used for a port \n Please use a different name"))(name_3), false, ReplaceType.NoReplace)];
                return createErrorMessage(linesLocations, locationOf(name_3), "Ports must have different names", extraMessages, name_3);
            }, map_2((tuple) => tuple[0], toList(filter((name_2, count) => (count > 1), ofSeq_1(countBy((x_2) => x_2, map_2((name_1) => name_1.toLocaleUpperCase(), portList), {
                Equals: (x_3, y_2) => (x_3 === y_2),
                GetHashCode: (x_3) => (stringHash(x_3) | 0),
            }), {
                Compare: (x_4, y_3) => (comparePrimitives(x_4, y_3) | 0),
            }))))));
        }
    }
}

/**
 * Checks whether all ports defined as input/output are declared as ports in the module header
 * Also checks for double definitions and for input ports not used in the assignments
 */
export function checkIODeclarations(ast, portWidthDeclarationMap, portLocationMap, linesLocations, nonUniquePortDeclarations, portMap, project, errorList) {
    const portList = ofArray(ast.Module.PortList);
    const PrimariesUsedExpr = append(map_2(getPrimaryName, collect((modInst) => getModuleInstantiationInputPrimaries(modInst, project), foldAST(getModuleInstantiationStatements, empty(), new ASTNode(/* VerilogInput */ 21, [ast])))), map_2(getPrimaryName, concat(map_2((expr) => primariesUsedInAssignment(empty(), expr), foldAST(getAllExpressions$0027, empty(), new ASTNode(/* VerilogInput */ 21, [ast]))))));
    return append(errorList, collect((port) => {
        const matchValue = contains(port, PrimariesUsedExpr, {
            Equals: (x, y) => (x === y),
            GetHashCode: (x) => (stringHash(x) | 0),
        });
        const matchValue_1 = tryFind_1(port, portMap);
        let matchResult;
        if (matchValue) {
            matchResult = 1;
        }
        else if (matchValue_1 != null) {
            if (matchValue_1.tag === 0) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                const alwaysFFs = filter_1((always) => equals(always.AlwaysType, AlwaysDU.AlwaysFF), foldAST(getAlwaysBlocks, empty(), new ASTNode(/* VerilogInput */ 21, [ast])));
                if ((port === "clk") && !equals(alwaysFFs, empty())) {
                    return errorList;
                }
                else {
                    return createErrorMessage(linesLocations, find(port, portLocationMap), toText(printf("Variable \'%s\' is defined as an input port but is not used"))(port), [new ExtraErrorInfo(toText(printf("Variable \'%s\' is defined as an input port but is not used \n Please delete it if it is not needed"))(port), false, ReplaceType.NoReplace)], port);
                }
            }
            default: {
                const matchValue_3 = contains(port, portList, {
                    Equals: (x_1, y_1) => (x_1 === y_1),
                    GetHashCode: (x_1) => (stringHash(x_1) | 0),
                });
                if (matchValue_3) {
                    if (contains(port, nonUniquePortDeclarations, {
                        Equals: (x_2, y_2) => (x_2 === y_2),
                        GetHashCode: (x_2) => (stringHash(x_2) | 0),
                    })) {
                        return createErrorMessage(linesLocations, find(port, portLocationMap), toText(printf("Port \'%s\' is already defined"))(port), [new ExtraErrorInfo(toText(printf("Port \'%s\' is already defined"))(port), false, ReplaceType.NoReplace)], port);
                    }
                    else {
                        return empty();
                    }
                }
                else {
                    return createErrorMessage(linesLocations, find(port, portLocationMap), toText(printf("Port \'%s\' is not defined as a port in the module declaration"))(port), [new ExtraErrorInfo(toText(printf("Port \'%s\' is not defined as a port \n Please define it in the module declaration"))(port), false, ReplaceType.NoReplace)], port);
                }
            }
        }
    }, map_2((tuple) => tuple[0], toList(portWidthDeclarationMap))));
}

/**
 * Checks whether the IO declarations have correct width format (i.e. Little-endian)
 */
export function checkIOWidthDeclarations(ast, paramMap, linesLocations, errorList) {
    let array;
    return append(errorList, collect((_arg_1) => {
        if (_arg_1.tag === 0) {
            const matchValue = _arg_1.fields[0].Range;
            if (matchValue != null) {
                const range = matchValue;
                let bStart;
                try {
                    bStart = evalExprWithParams(range.Start, paramMap);
                }
                catch (matchValue_1) {
                    bStart = undefined;
                }
                let bEnd;
                try {
                    bEnd = evalExprWithParams(range.End, paramMap);
                }
                catch (matchValue_2) {
                    bEnd = undefined;
                }
                let matchResult, bEnd_1, bStart_1;
                if (bStart != null) {
                    if (bEnd != null) {
                        matchResult = 1;
                        bEnd_1 = bEnd;
                        bStart_1 = bStart;
                    }
                    else {
                        matchResult = 0;
                    }
                }
                else {
                    matchResult = 0;
                }
                switch (matchResult) {
                    case 0:
                        return createErrorMessage(linesLocations, range.Location, "Width declaration must evaluate to constant", [new ExtraErrorInfo(toText(printf("A port\'s width must be compile-time constant. Did you mispell a parameter?")), false, ReplaceType.NoReplace)], "[0:0]");
                    default:
                        if ((bEnd_1 !== 0) ? true : (bStart_1 <= bEnd_1)) {
                            const temp = (bStart_1 <= bEnd_1) ? "\nBig-Endian format is not allowed yet by ISSIE" : "";
                            return createErrorMessage(linesLocations, range.Location, "Wrong width declaration", [new ExtraErrorInfo(toText(printf("A port\'s width can\'t be \'[%i:%i]\'\nCorrect form: [X:0]"))(bStart_1)(bEnd_1) + temp, false, ReplaceType.NoReplace)], int32ToString(bStart_1) + "[:0]");
                        }
                        else {
                            return empty();
                        }
                }
            }
            else {
                return empty();
            }
        }
        else {
            return empty();
        }
    }, ofArray((array = convertModule(ast.Module).ModuleItems.ItemList, array.filter((_arg) => {
        let declType;
        let matchResult_1, declType_1;
        if (_arg.tag === 0) {
            if ((declType = _arg.fields[0].DeclarationType, equals(declType, DeclarationDU.OutputDecl) ? true : equals(declType, DeclarationDU.InputDecl))) {
                matchResult_1 = 0;
                declType_1 = _arg.fields[0].DeclarationType;
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0:
                return true;
            default:
                return false;
        }
    })))));
}

/**
 * Checks if the name of the module is valid (i.e. this sheet doesn't exist)
 */
export function nameCheck(ast, linesLocations, origin, project, errorList) {
    const moduleName = ast.Module.ModuleName.Name;
    let patternInput;
    if (origin.tag === 1) {
        const initialName = origin.fields[0];
        patternInput = [moduleName !== initialName, initialName];
    }
    else {
        patternInput = [isFileInProject(moduleName, project), ""];
    }
    return append(patternInput[0] ? ((origin.tag === 1) ? createErrorMessage(linesLocations, ast.Module.ModuleName.Location, "Verilog component\'s name cannot be changed ", [new ExtraErrorInfo("Module Name of Verilog component cannot be changed", false, ReplaceType.NoReplace), new ExtraErrorInfo(toText(printf("%s"))(patternInput[1]), true, new ReplaceType(/* Variable */ 2, [moduleName]))], moduleName) : createErrorMessage(linesLocations, ast.Module.ModuleName.Location, "A sheet/component with that name already exists", [new ExtraErrorInfo("Module Name must be different from existing Sheets/Components", false, ReplaceType.NoReplace)], moduleName)) : empty(), errorList);
}

export function getIdentifiers(identifiers, node) {
    if (node.tag === 13) {
        return append(identifiers, singleton(getPrimaryName(node.fields[0])));
    }
    else {
        return identifiers;
    }
}

export function getParamsUsed(ast, paramMap) {
    return fold((parameters, i) => {
        const matchValue = tryFind_1(i, paramMap);
        if (matchValue == null) {
            return parameters;
        }
        else {
            return append(singleton(i), parameters);
        }
    }, empty(), foldAST(getIdentifiers, empty(), new ASTNode(/* VerilogInput */ 21, [ast])));
}

export function getParamDeclarations(paramDeclarations, node) {
    if (node.tag === 1) {
        return append(paramDeclarations, ofArray(node.fields[0].Parameters));
    }
    else {
        return paramDeclarations;
    }
}

/**
 * Checks parameters declared have been used
 */
export function checkParamsUsed(ast, linesLocations, paramMap, errorList) {
    let array_1;
    const paramsUsed = getParamsUsed(ast, paramMap);
    const paramDecls = foldAST(getParamDeclarations, empty(), new ASTNode(/* VerilogInput */ 21, [ast]));
    const paramUsedErrors = append(errorList, collect((parameter) => {
        const paramName = parameter.Identifier.Name;
        const matchValue = contains(paramName, paramsUsed, {
            Equals: (x, y) => (x === y),
            GetHashCode: (x) => (stringHash(x) | 0),
        });
        if (matchValue) {
            return empty();
        }
        else {
            return createErrorMessage(linesLocations, parameter.Identifier.Location, toText(printf("Parameter \'%s\' is defined but is not used"))(paramName), [new ExtraErrorInfo(toText(printf("Parameter \'%s\' is defined but is not used. \n Please delete it if it is not needed"))(paramName), false, ReplaceType.NoReplace)], paramName);
        }
    }, paramDecls));
    const decls_1 = concat(append(map_2((d) => ofArray(d.Variables), foldAST(getDeclarations, empty(), new ASTNode(/* VerilogInput */ 21, [ast]))), map_2((_arg_1) => {
        if (_arg_1.tag === 0) {
            return ofArray(_arg_1.fields[0].Variables);
        }
        else {
            return empty();
        }
    }, ofArray((array_1 = convertModule(ast.Module).ModuleItems.ItemList, array_1.filter((_arg) => {
        let declType;
        let matchResult, declType_1;
        if (_arg.tag === 0) {
            if ((declType = _arg.fields[0].DeclarationType, equals(declType, DeclarationDU.OutputDecl) ? true : equals(declType, DeclarationDU.InputDecl))) {
                matchResult = 0;
                declType_1 = _arg.fields[0].DeclarationType;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return true;
            default:
                return false;
        }
    }))))));
    const paramSet = ofList_1(map_2((p) => p.Identifier.Name, paramDecls), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    });
    return append(paramUsedErrors, collect((decl) => {
        const extraMessages_1 = [new ExtraErrorInfo(toText(printf("Identifier \'%s\' is declared both as a parameter and as a variable/port\n Please change one."))(decl.Name), false, ReplaceType.NoReplace)];
        return createErrorMessage(linesLocations, decl.Location, toText(printf("Conflicting declaration \'%s\'"))(decl.Name), extraMessages_1, decl.Name);
    }, filter_1((d_1) => contains_1(d_1.Name, paramSet), decls_1)));
}

/**
 * Checks if all declared output ports have a value assigned to them
 * The check is done bit-by-bit
 */
export function checkAllOutputsAssigned(ast, portMap, portSizeMap, paramMap, linesLocations, errorList) {
    const outputPortListMap = collect((x) => map_2((y) => [x + int32ToString(y), x], toList_1(rangeDouble(0, 1, find(x, portSizeMap) - 1))), map_2((tuple) => tuple[0], toList(filter((_arg, s) => equals(s, DeclarationDU.OutputDecl), portMap))));
    const outputPortList = map_2((tuple_1) => tuple_1[0], outputPortListMap);
    const assignmentPortList = collect((x_1) => {
        let matchResult, name_3, x_4, y_4, bEnd_2, bStart_2, name_4;
        if (x_1[1] === -1) {
            if (x_1[2] === -1) {
                matchResult = 0;
            }
            else if (x_1[1] === x_1[2]) {
                matchResult = 1;
                name_3 = x_1[0];
                x_4 = x_1[1];
                y_4 = x_1[2];
            }
            else {
                matchResult = 2;
                bEnd_2 = x_1[2];
                bStart_2 = x_1[1];
                name_4 = x_1[0];
            }
        }
        else if (x_1[1] === x_1[2]) {
            matchResult = 1;
            name_3 = x_1[0];
            x_4 = x_1[1];
            y_4 = x_1[2];
        }
        else {
            matchResult = 2;
            bEnd_2 = x_1[2];
            bStart_2 = x_1[1];
            name_4 = x_1[0];
        }
        switch (matchResult) {
            case 0: {
                const name_2 = x_1[0];
                const matchValue_2 = tryFind_1(name_2, portSizeMap);
                if (matchValue_2 == null) {
                    return empty();
                }
                else {
                    return map_2((y_3) => (name_2 + int32ToString(y_3)), toList_1(rangeDouble(0, 1, matchValue_2 - 1)));
                }
            }
            case 1:
                return singleton(name_3 + int32ToString(x_4));
            default:
                return map_2((y_5) => (name_4 + int32ToString(y_5)), toList_1(rangeDouble(bEnd_2, 1, bStart_2)));
        }
    }, foldAST((vars, node) => {
        switch (node.tag) {
            case 2: {
                const contAssign = node.fields[0];
                const matchValue = getPrimaryRange(contAssign.Assignment.LHS.PrimaryType, paramMap);
                if (matchValue != null) {
                    const bStart = matchValue[0] | 0;
                    const bEnd = matchValue[1] | 0;
                    return append(vars, singleton([getPrimaryName(contAssign.Assignment.LHS.PrimaryType), bStart, bEnd]));
                }
                else {
                    return append(vars, singleton([getPrimaryName(contAssign.Assignment.LHS.PrimaryType), -1, -1]));
                }
            }
            case 5: {
                const stmt = node.fields[0];
                switch (stmt.tag) {
                    case 1:
                        return append(vars, singleton([getPrimaryName(stmt.fields[0].LHS.PrimaryType), -1, -1]));
                    case 0:
                        return append(vars, singleton([getPrimaryName(stmt.fields[0].LHS.PrimaryType), -1, -1]));
                    default:
                        return vars;
                }
            }
            case 22:
                return append(vars, map_2((connection) => {
                    const matchValue_1 = getPrimaryRange(connection.Primary, paramMap);
                    if (matchValue_1 != null) {
                        const bStart_1 = matchValue_1[0] | 0;
                        const bEnd_1 = matchValue_1[1] | 0;
                        return [getPrimaryName(connection.Primary), bStart_1, bEnd_1];
                    }
                    else {
                        return [getPrimaryName(connection.Primary), -1, -1];
                    }
                }, ofArray(node.fields[0].Connections)));
            default:
                return vars;
        }
    }, empty(), new ASTNode(/* VerilogInput */ 21, [ast])));
    const genErrorMessage = (portList, mapping_7, errorType, mess) => {
        let arg_1;
        if (isEmpty_1(portList)) {
            return empty();
        }
        else {
            const fullNames = collect((x_5) => {
                const matchValue_4 = tryFind_1(x_5, ofList(mapping_7, {
                    Compare: (x_6, y_6) => (compare(x_6, y_6) | 0),
                }));
                if (matchValue_4 == null) {
                    return empty();
                }
                else {
                    const name_5 = matchValue_4;
                    return singleton(((name_5 + "[") + StringModule_Concat("", map_3((value) => value, except(name_5.split(""), x_5, {
                        Equals: (x_7, y_7) => (x_7 === y_7),
                        GetHashCode: (x_7) => (stringHash(x_7) | 0),
                    })))) + "]");
                }
            }, portList);
            const extraMessages = (errorType.tag === 1) ? [] : [new ExtraErrorInfo(toText(printf("The following ports are declared but not assigned: %A"))(fullNames), false, ReplaceType.NoReplace), new ExtraErrorInfo((arg_1 = item_2(0, fullNames), toText(printf("assign %s = 1\'b0;"))(arg_1)), true, ReplaceType.Assignment)];
            if (errorType.tag === 0) {
                return createErrorMessage(linesLocations, ast.Module.EndLocation, mess, extraMessages, "endmodule");
            }
            else {
                return empty();
            }
        }
    };
    const notUnique = map_2((tuple_2) => tuple_2[0], filter_1((tupledArg) => (tupledArg[1] > 1), List_countBy((x_8) => x_8, assignmentPortList, {
        Equals: (x_9, y_8) => (x_9 === y_8),
        GetHashCode: (x_9) => (stringHash(x_9) | 0),
    })));
    const unassignedPorts = List_except(assignmentPortList, outputPortList, {
        Equals: (x_10, y_10) => (x_10 === y_10),
        GetHashCode: (x_10) => (stringHash(x_10) | 0),
    });
    return append(errorList, isEmpty_1(unassignedPorts) ? genErrorMessage(notUnique, outputPortListMap, PortAssignmentError.DoubleAssignment, "Some output ports have been assigned more than once") : genErrorMessage(unassignedPorts, outputPortListMap, PortAssignmentError.Unassigned, "All output ports must be assigned"));
}

/**
 * Checks that loop variables in for loops are not assigned to inside the loop body
 */
export function checkForLoopVar(ast, linesLocations, errorList) {
    return append(errorList, collect((tupledArg) => {
        const forStmt = tupledArg[0];
        const loopVarName = getPrimaryName(forStmt.Initialisation.LHS.PrimaryType);
        const loopVarAssignments = filter_1((assign) => (getPrimaryName(assign.LHS.PrimaryType) === loopVarName), foldAST(getAssignments$0027, empty(), new ASTNode(/* Statement */ 5, [forStmt.Statement])));
        if (isEmpty_1(loopVarAssignments)) {
            return empty();
        }
        else {
            return collect((assign_1) => {
                const extraMessages = [new ExtraErrorInfo(toText(printf("The loop variable \'%s\' is assigned to inside the loop. The loop variable should not be assigned to inside the loop body."))(loopVarName), false, ReplaceType.NoReplace)];
                const message = toText(printf("Loop variable should not be assigned to inside the loop"));
                return createErrorMessage(linesLocations, lhsLocation(assign_1.LHS), message, extraMessages, loopVarName);
            }, loopVarAssignments);
        }
    }, foldAST(getForStatementsWithLoc, empty(), new ASTNode(/* VerilogInput */ 21, [ast]))));
}

/**
 * Checks estimated program size after loop unrolling.
 */
export function checkForLoopUnrollCost(ast, paramMap, linesLocations, errorList) {
    const tryEval = (expr) => {
        try {
            return new FSharpResult$2(/* Ok */ 0, [evalExprWithParams(expr, paramMap)]);
        }
        catch (matchValue) {
            return new FSharpResult$2(/* Error */ 1, ["For loop bounds must be constant."]);
        }
    };
    const mkError = (loc, name, message, detail) => createErrorMessage(linesLocations, loc, message, [new ExtraErrorInfo(detail, false, ReplaceType.NoReplace)], name);
    const estimateUnrolledStatementCost = (stmt) => {
        let option_1, option_4;
        switch (stmt.tag) {
            case 0:
                return [empty(), estimateAssignmentCost(stmt.fields[0])];
            case 2:
                return fold_1((tupledArg, s) => {
                    const patternInput_2 = estimateUnrolledStatementCost(s);
                    return [append(tupledArg[0], patternInput_2[0]), tupledArg[1] + patternInput_2[1]];
                }, [empty(), 0], stmt.fields[0]);
            case 3: {
                const c = stmt.fields[0];
                const patternInput_4 = fold_1((tupledArg_1, item) => {
                    const patternInput_3 = estimateUnrolledStatementCost(item.Statement);
                    return [append(tupledArg_1[0], patternInput_3[0]), tupledArg_1[1] + patternInput_3[1]];
                }, [empty(), 0], c.CaseItems);
                const patternInput_5 = defaultArg((option_1 = c.Default, (option_1 != null) ? estimateUnrolledStatementCost(option_1) : undefined), [empty(), 0]);
                return [append(patternInput_4[0], patternInput_5[0]), ((1 + estimateExprCost(c.Expression)) + patternInput_4[1]) + patternInput_5[1]];
            }
            case 4: {
                const ifStmt = stmt.fields[0];
                const patternInput_6 = estimateUnrolledStatementCost(ifStmt.Statement);
                const patternInput_7 = defaultArg((option_4 = stmt.fields[1], (option_4 != null) ? estimateUnrolledStatementCost(option_4) : undefined), [empty(), 0]);
                return [append(patternInput_6[0], patternInput_7[0]), ((1 + estimateExprCost(ifStmt.Condition)) + patternInput_6[1]) + patternInput_7[1]];
            }
            case 5: {
                const f_1 = stmt.fields[0];
                const loopVarName = getPrimaryName(f_1.Initialisation.LHS.PrimaryType);
                let matchValue_9;
                const f = f_1;
                const startRes = tryEval(f.Initialisation.RHS);
                let patternInput;
                const matchValue_1 = f.Step.RHS;
                let matchResult, step, step_1;
                if (matchValue_1.tag === 9) {
                    switch (matchValue_1.fields[0].tag) {
                        case 14: {
                            matchResult = 0;
                            step = matchValue_1.fields[2];
                            break;
                        }
                        case 15: {
                            matchResult = 1;
                            step_1 = matchValue_1.fields[2];
                            break;
                        }
                        default:
                            matchResult = 2;
                    }
                }
                else {
                    matchResult = 2;
                }
                switch (matchResult) {
                    case 0: {
                        patternInput = [tryEval(step), empty()];
                        break;
                    }
                    case 1: {
                        patternInput = [tryEval(step_1), empty()];
                        break;
                    }
                    default:
                        patternInput = [new FSharpResult$2(/* Error */ 1, ["Invalid for loop step"]), createErrorMessage(linesLocations, f.Location, "For loop step must be an addition or subtraction.", [new ExtraErrorInfo("For loop step must be an addition or subtraction.", false, ReplaceType.NoReplace)], getPrimaryName(f.Initialisation.LHS.PrimaryType))];
                }
                const localErrors = patternInput[1];
                let condRes;
                const matchValue_2 = f.Condition;
                condRes = ((matchValue_2.tag === 7) ? (new FSharpResult$2(/* Ok */ 0, [[matchValue_2.fields[0], matchValue_2.fields[2]]])) : (new FSharpResult$2(/* Error */ 1, ["For loop condition must be a comparison."])));
                const copyOfStruct = startRes;
                if (copyOfStruct.tag === 1) {
                    matchValue_9 = [new FSharpResult$2(/* Error */ 1, [copyOfStruct.fields[0]]), append(localErrors, createErrorMessage(linesLocations, f.Location, copyOfStruct.fields[0], [new ExtraErrorInfo("For loop initialisation must evaluate to a constant.", false, ReplaceType.NoReplace)], getPrimaryName(f.Initialisation.LHS.PrimaryType)))];
                }
                else {
                    const copyOfStruct_1 = patternInput[0];
                    if (copyOfStruct_1.tag === 1) {
                        matchValue_9 = [new FSharpResult$2(/* Error */ 1, [copyOfStruct_1.fields[0]]), append(localErrors, createErrorMessage(linesLocations, f.Location, copyOfStruct_1.fields[0], [new ExtraErrorInfo("For loop step must be an addition or subtraction.", false, ReplaceType.NoReplace)], getPrimaryName(f.Initialisation.LHS.PrimaryType)))];
                    }
                    else {
                        const copyOfStruct_2 = condRes;
                        if (copyOfStruct_2.tag === 1) {
                            matchValue_9 = [new FSharpResult$2(/* Error */ 1, [copyOfStruct_2.fields[0]]), append(localErrors, createErrorMessage(linesLocations, f.Location, copyOfStruct_2.fields[0], [new ExtraErrorInfo("For loop condition must be a comparison.", false, ReplaceType.NoReplace)], getPrimaryName(f.Initialisation.LHS.PrimaryType)))];
                        }
                        else {
                            const matchValue_4 = tryEval(copyOfStruct_2.fields[0][1]);
                            if (matchValue_4.tag === 1) {
                                const msg = matchValue_4.fields[0];
                                matchValue_9 = [new FSharpResult$2(/* Error */ 1, [msg]), append(localErrors, createErrorMessage(linesLocations, f.Location, msg, [new ExtraErrorInfo("For loop condition must evaluate to a constant.", false, ReplaceType.NoReplace)], getPrimaryName(f.Initialisation.LHS.PrimaryType)))];
                            }
                            else {
                                const endV = matchValue_4.fields[0] | 0;
                                const matchValue_5 = f.Step.RHS;
                                let matchResult_1;
                                if (matchValue_5.tag === 9) {
                                    switch (matchValue_5.fields[0].tag) {
                                        case 14: {
                                            matchResult_1 = 0;
                                            break;
                                        }
                                        case 15: {
                                            matchResult_1 = 1;
                                            break;
                                        }
                                        default:
                                            matchResult_1 = 2;
                                    }
                                }
                                else {
                                    matchResult_1 = 2;
                                }
                                switch (matchResult_1) {
                                    case 0: {
                                        const stepFloat = copyOfStruct_1.fields[0];
                                        const startFloat = copyOfStruct.fields[0];
                                        const endFloat = endV;
                                        matchValue_9 = ((copyOfStruct_2.fields[0][0].tag === 10) ? [new FSharpResult$2(/* Ok */ 0, [[copyOfStruct_1.fields[0], ~~(Math.floor(endFloat - startFloat) / stepFloat)]]), localErrors] : ((copyOfStruct_2.fields[0][0].tag === 11) ? [new FSharpResult$2(/* Ok */ 0, [[copyOfStruct_1.fields[0], ~~(Math.floor((endFloat - startFloat) + 1) / stepFloat)]]), localErrors] : ((copyOfStruct_2.fields[0][0].tag === 13) ? [new FSharpResult$2(/* Ok */ 0, [[copyOfStruct_1.fields[0], ~~(Math.floor((startFloat - endFloat) + 1) / stepFloat)]]), localErrors] : ((copyOfStruct_2.fields[0][0].tag === 12) ? [new FSharpResult$2(/* Ok */ 0, [[copyOfStruct_1.fields[0], ~~(Math.floor(startFloat - endFloat) / stepFloat)]]), localErrors] : [new FSharpResult$2(/* Error */ 1, ["Unsupported for loop comparison operator."]), append(localErrors, createErrorMessage(linesLocations, f.Location, "Unsupported for loop comparison operator.", [new ExtraErrorInfo("For loop condition must be a comparision.", false, ReplaceType.NoReplace)], getPrimaryName(f.Initialisation.LHS.PrimaryType)))]))));
                                        break;
                                    }
                                    case 1: {
                                        matchValue_9 = ((copyOfStruct_2.fields[0][0].tag === 12) ? [new FSharpResult$2(/* Ok */ 0, [[copyOfStruct_1.fields[0], copyOfStruct.fields[0] - endV]]), localErrors] : ((copyOfStruct_2.fields[0][0].tag === 13) ? [new FSharpResult$2(/* Ok */ 0, [[copyOfStruct_1.fields[0], (copyOfStruct.fields[0] - endV) + 1]]), localErrors] : ((copyOfStruct_2.fields[0][0].tag === 10) ? [new FSharpResult$2(/* Ok */ 0, [[copyOfStruct_1.fields[0], copyOfStruct.fields[0] - endV]]), localErrors] : ((copyOfStruct_2.fields[0][0].tag === 11) ? [new FSharpResult$2(/* Ok */ 0, [[copyOfStruct_1.fields[0], (copyOfStruct.fields[0] - endV) + 1]]), localErrors] : [new FSharpResult$2(/* Error */ 1, ["Unsupported for loop comparison operator."]), append(localErrors, createErrorMessage(linesLocations, f.Location, "Unsupported for loop comparison operator.", [new ExtraErrorInfo("For loop condition must be a comparision.", false, ReplaceType.NoReplace)], getPrimaryName(f.Initialisation.LHS.PrimaryType)))]))));
                                        break;
                                    }
                                    default:
                                        matchValue_9 = [new FSharpResult$2(/* Error */ 1, ["Invalid for loop step"]), append(localErrors, createErrorMessage(linesLocations, f.Location, "Invalid for loop step.", [new ExtraErrorInfo("For loop step must be an addition or subtraction.", false, ReplaceType.NoReplace)], getPrimaryName(f.Initialisation.LHS.PrimaryType)))];
                                }
                            }
                        }
                    }
                }
                const copyOfStruct_3 = matchValue_9[0];
                if (copyOfStruct_3.tag === 0) {
                    if (copyOfStruct_3.fields[0][0] === 0) {
                        return [append(matchValue_9[1], mkError(f_1.Location, loopVarName, "Infinite for loop!", "For loop step must be a non-zero constant.")), 0];
                    }
                    else if (copyOfStruct_3.fields[0][1] <= 0) {
                        return [append(matchValue_9[1], mkError(f_1.Location, loopVarName, "Infinite for loop!", "For loop bounds must not create an infinite loop.")), 0];
                    }
                    else {
                        const patternInput_8 = estimateUnrolledStatementCost(f_1.Statement);
                        const totalCost = (copyOfStruct_3.fields[0][1] * patternInput_8[1]) | 0;
                        return [append(matchValue_9[1], patternInput_8[0]), totalCost];
                    }
                }
                else {
                    return [append(matchValue_9[1], mkError(f_1.Location, loopVarName, "Invalid for loop bounds", copyOfStruct_3.fields[0])), 0];
                }
            }
            default:
                return [empty(), estimateAssignmentCost(stmt.fields[0])];
        }
    };
    const patternInput_10 = fold((tupledArg_2, item_1) => {
        let patternInput_9;
        const matchValue_10 = item_1.Statement;
        const matchValue_11 = item_1.AlwaysConstruct;
        patternInput_9 = ((matchValue_10 == null) ? ((matchValue_11 != null) ? estimateUnrolledStatementCost(convertStatement(matchValue_11.Statement)) : [empty(), 0]) : [empty(), estimateAssignmentCost(convertAssignment(matchValue_10.Assignment, AssignDU.Blocking))]);
        return [append(tupledArg_2[0], patternInput_9[0]), tupledArg_2[1] + patternInput_9[1]];
    }, [empty(), 0], ofArray(ast.Module.ModuleItems.ItemList));
    return append(errorList, append(patternInput_10[0], (patternInput_10[1] > 500) ? mkError(ast.Module.ModuleName.Location, ast.Module.ModuleName.Name, "Program too large", toText(printf("Estimated number of components to be synthesised exceeds the memory limit."))) : empty()));
}

/**
 * Helper recursive function to transform the produced OneUnary-type tree
 * by RHSUnaryAnalysis to a string which can be used for ErrorInfo
 */
export function unaryTreeToString(treeDepth, targetLength, unary) {
    const targetLength$0027 = targetLength | 0;
    const depthToSpaces = fold((s, v) => (s + "   "), "", toList_1(rangeDouble(0, 1, treeDepth)));
    const sizeString = (targetLength$0027 === -2) ? ((unary.ResultWidth !== 1) ? (int32ToString(unary.ResultWidth) + " -> ERROR! (Exp: 1, condition must be a single bit!)") : int32ToString(unary.ResultWidth)) : ((targetLength$0027 === -1) ? int32ToString(unary.ResultWidth) : ((targetLength$0027 === unary.ResultWidth) ? int32ToString(unary.ResultWidth) : (((int32ToString(unary.ResultWidth) + " -> ERROR! (Exp: ") + int32ToString(targetLength$0027)) + ")")));
    let propagatedLength;
    const matchValue = unary.Name;
    propagatedLength = ((matchValue === "{...}") ? -1 : ((matchValue === "[condition]") ? targetLength : ((matchValue === "[reduction]") ? -1 : ((matchValue === "[logical_op]") ? -1 : unary.ResultWidth))));
    let elem;
    const matchValue_1 = unary.Name;
    let matchResult;
    switch (matchValue_1) {
        case "[bitwise_op]":
        case "[logical_op]": {
            matchResult = 0;
            break;
        }
        case "[conditional]": {
            matchResult = 1;
            break;
        }
        case "(...)": {
            matchResult = 3;
            break;
        }
        case "[shift]": {
            matchResult = 4;
            break;
        }
        case "{...}": {
            matchResult = 5;
            break;
        }
        case "[reduction]": {
            if (equals(unary.Elements, empty())) {
                matchResult = 2;
            }
            else {
                matchResult = 3;
            }
            break;
        }
        default:
            matchResult = 6;
    }
    switch (matchResult) {
        case 0: {
            elem = (unaryTreeToString(treeDepth + 2, propagatedLength, value_2(unary.Head)) + unaryTreeToString(treeDepth + 2, propagatedLength, value_2(unary.Tail)));
            break;
        }
        case 1: {
            elem = ((unaryTreeToString(treeDepth + 2, -2, item_2(0, unary.Elements)) + unaryTreeToString(treeDepth + 2, propagatedLength, value_2(unary.Head))) + unaryTreeToString(treeDepth + 2, propagatedLength, value_2(unary.Tail)));
            break;
        }
        case 2: {
            elem = "";
            break;
        }
        case 3: {
            elem = unaryTreeToString(treeDepth + 2, propagatedLength, item_2(0, unary.Elements));
            break;
        }
        case 4: {
            elem = "";
            break;
        }
        case 5: {
            elem = fold((s_1, v_1) => (s_1 + unaryTreeToString(treeDepth + 2, propagatedLength, item_2(v_1, unary.Elements))), "", toList_1(rangeDouble(0, 1, length_1(unary.Elements) - 1)));
            break;
        }
        default:
            elem = "";
    }
    if (elem === "") {
        return ((((depthToSpaces + "-\'") + unary.Name) + "\' with Width: ") + sizeString) + "\n";
    }
    else {
        return ((((((((depthToSpaces + "-\'") + unary.Name) + "\' with Width: ") + sizeString) + "\n") + depthToSpaces) + "   ") + "Elements: \n") + elem;
    }
}

/**
 * Checks one-by-one all wire and output port assignments for:
 * 1) LHS Name and Width
 * 2) RHS Names
 * 3) RHS Width of inputs/wires
 * 4) Width LHS = Width RHS
 */
export function checkWiresAndAssignments(ast, portMap, portSizeMap, portWidthDeclarationMap, inputNameList, linesLocations, wireNameList, wireSizeMap, wireLocationMap, arraySizeMap, paramMap, errorList) {
    const wireNameList$0027 = append(wireNameList, map_2((id) => id.Name, collect((decl) => ofArray(decl.Variables), foldAST(getDeclarations, empty(), new ASTNode(/* VerilogInput */ 21, [ast])))));
    const portAndWireNames = append(wireNameList$0027, map_2((tuple) => tuple[0], toList(portMap)));
    const outputNameList = MapModule_KeysL(portMap);
    const getCurrentInputWireList = (location) => append(outputNameList, append(inputNameList, filter_1((x) => {
        const matchValue = tryFind_1(x, wireLocationMap);
        if (matchValue == null) {
            return false;
        }
        else {
            return location > matchValue;
        }
    }, wireNameList$0027)));
    const getCurrentParamList = map_2((tuple_1) => tuple_1[0], toList(paramMap));
    const getPortTypesString = (portType) => {
        switch (portType.tag) {
            case 1:
                return "output";
            case 2:
                return "logic";
            case 3:
                return "parameter";
            default:
                return "input";
        }
    };
    const checkNamesInPrimaries = (primariesRHS, currentInputWireList, localErrors_3) => {
        const namesWithLocRHS = map_2((x_3) => [getPrimaryName(x_3), getPrimaryLocation(x_3)], primariesRHS);
        const namesRHS = map_2((tuple_2) => tuple_2[0], namesWithLocRHS);
        const namesToLocMap = ofList(namesWithLocRHS, {
            Compare: (x_4, y) => (comparePrimitives(x_4, y) | 0),
        });
        const diff = List_except(append(currentInputWireList, singleton("delete123")), namesRHS, {
            Equals: (x_5, y_1) => (x_5 === y_1),
            GetHashCode: (x_5) => (stringHash(x_5) | 0),
        });
        if (isEmpty_1(diff)) {
            return localErrors_3;
        }
        else {
            return collect((name) => {
                let arg_37;
                const currLocation = find(name, namesToLocMap) | 0;
                if (exists_1((x_6) => (x_6 === name), wireNameList$0027)) {
                    return createErrorMessage(linesLocations, currLocation, toText(printf("Variable \'%s\' is defined after this assignment"))(name), [new ExtraErrorInfo(toText(printf("Variable \'%s\' is defined after this assignment"))(name), false, ReplaceType.NoReplace), new ExtraErrorInfo(toText(printf("Move the definition of variable \'%s\' above this line"))(name), false, ReplaceType.NoReplace)], name);
                }
                else {
                    const closeVariables = findCloseVariable(name.split(""), portAndWireNames);
                    if (isEmpty_1(closeVariables)) {
                        return createErrorMessage(linesLocations, currLocation, toText(printf("Variable \'%s\' is not declared as input or variable"))(name), append_1([new ExtraErrorInfo(toText(printf("Variable \'%s\' is not declared as input or variable"))(name), false, ReplaceType.NoReplace)], (ast.Module.Type === "module_new") ? [] : [new ExtraErrorInfo(toText(printf("input bit %s;|bit %s = 1\'b0;"))(name)(name), true, ReplaceType.IODeclaration)]), name);
                    }
                    else {
                        return createErrorMessage(linesLocations, currLocation, toText(printf("Variable \'%s\' is not declared as input or variable"))(name), [new ExtraErrorInfo(toText(printf("Variable \'%s\' is not declared as input or variable"))(name), false, ReplaceType.NoReplace), new ExtraErrorInfo((arg_37 = item_2(0, closeVariables), toText(printf("%s"))(arg_37)), true, new ReplaceType(/* Variable */ 2, [name]))], name);
                    }
                }
            }, diff);
        }
    };
    const checkNamesOnRHSOfAssignment = (expression, currentInputWireList_1, localErrors_4) => checkNamesInPrimaries(primariesUsedInAssignment(empty(), expression), append(currentInputWireList_1, getCurrentParamList), localErrors_4);
    const getCurrentInputWireSizeMap = (location_1) => {
        let list_12;
        return ofList((list_12 = toList(filter((wire_2, _arg) => {
            const matchValue_21 = tryFind_1(wire_2, wireLocationMap);
            if (matchValue_21 == null) {
                return false;
            }
            else {
                return location_1 > matchValue_21;
            }
        }, wireSizeMap)), append(toList(portSizeMap), list_12)), {
            Compare: (x_7, y_2) => (comparePrimitives(x_7, y_2) | 0),
        });
    };
    const notUniqeWireNames = map_2((tuple_3) => tuple_3[0], filter_1((tupledArg) => (tupledArg[1] > 1), List_countBy((x_8) => x_8, append(wireNameList, map_2((var$) => var$.Name, collect((decl_2) => ofArray(decl_2.Variables), foldAST(getDeclarations, empty(), new ASTNode(/* VerilogInput */ 21, [ast]))))), {
        Equals: (x_9, y_3) => (x_9 === y_3),
        GetHashCode: (x_9) => (stringHash(x_9) | 0),
    })));
    const assignmentsWithLocation = foldAST(getAssignmentsWithLocations, empty(), new ASTNode(/* VerilogInput */ 21, [ast]));
    const moduleInstantiationErrors = collect((primary) => {
        const list_21 = checkNamesInPrimaries(singleton(primary), getCurrentInputWireList(getPrimaryLocation(primary)), empty());
        return append(checkPrimariesWidths(linesLocations, getCurrentInputWireSizeMap(getPrimaryLocation(primary)), arraySizeMap, paramMap, empty(), singleton(primary), empty()), list_21);
    }, map_2((conn) => conn.Primary, collect((modInst) => ofArray(modInst.Connections), foldAST(getModuleInstantiationStatements, empty(), new ASTNode(/* VerilogInput */ 21, [ast])))));
    const localErrors_6 = append(moduleInstantiationErrors, append(moduleInstantiationErrors, collect((tupledArg_1) => {
        let errlst, localErrors, lhs, lhsName, lhsLoc, matchValue_1, portTypeS, matchValue_2, matchValue_3, bStart, bEnd, localErrors_2, lhs_2, lhsName_1, lhsLoc_1, matchValue_10, found_3, matchValue_11, bStart_3, bEnd_3, matchValue_12, lhsStart, lhsEnd, definition, patternInput, matchValue_23;
        const assignment_2 = tupledArg_1[0];
        const location_2 = tupledArg_1[1] | 0;
        const currentInputWireList_3 = getCurrentInputWireList(location_2);
        const currentInputWireSizeMap_2 = getCurrentInputWireSizeMap(location_2);
        const errlst_1 = checkExpr(linesLocations, currentInputWireSizeMap_2, arraySizeMap, paramMap, (errlst = checkNamesOnRHSOfAssignment(assignment_2.RHS, currentInputWireList_3, (assignment_2.Type.tag === 2) ? ((localErrors = empty(), (lhs = assignment_2.LHS.PrimaryType, (lhsName = getPrimaryName(lhs), (lhsLoc = (getPrimaryLocation(lhs) | 0), (matchValue_1 = tryFind_1(lhsName, portMap), (matchValue_1 != null) ? ((portTypeS = getPortTypesString(matchValue_1), createErrorMessage(linesLocations, lhsLoc, toText(printf("Variable \'%s\' is already used by a port"))(lhsName), [new ExtraErrorInfo(toText(printf("Variable \'%s\' is declared as an %s port\nPlease use a different name for this wire"))(lhsName)(portTypeS), false, ReplaceType.NoReplace)], lhsName))) : ((matchValue_2 = tryFind((x_1) => (x_1 === lhsName), notUniqeWireNames), (matchValue_2 != null) ? (createErrorMessage(linesLocations, lhsLoc, toText(printf("Identifier \'%s\' is already used by another variable"))(lhsName), [new ExtraErrorInfo(toText(printf("Identifier \'%s\' is already used by another variable\nPlease use a different name for this wire"))(lhsName), false, ReplaceType.NoReplace)], lhsName)) : ((matchValue_3 = getPrimaryRange(lhs, paramMap), (matchValue_3 != null) ? ((bStart = (matchValue_3[0] | 0), (bEnd = (matchValue_3[1] | 0), ((bEnd !== 0) ? true : (bStart <= bEnd)) ? createErrorMessage(linesLocations, lhsLoc, "Wrong width declaration", [new ExtraErrorInfo(toText(printf("A port\'s width can\'t be \'[%i:%i]\'\nCorrect form: [X:0]"))(bStart)(bEnd), false, ReplaceType.NoReplace)], lhsName) : localErrors))) : localErrors)))))))))) : ((localErrors_2 = empty(), (lhs_2 = assignment_2.LHS.PrimaryType, (lhsName_1 = getPrimaryName(lhs_2), (lhsLoc_1 = (getPrimaryLocation(lhs_2) | 0), (matchValue_10 = tryFind_1(lhsName_1, portMap), (matchValue_10 != null) ? (equals(matchValue_10, DeclarationDU.OutputDecl) ? ((found_3 = matchValue_10, (matchValue_11 = tryFind_1(lhsName_1, portWidthDeclarationMap), (matchValue_11 == null) ? toFail(printf("Can\'t happen! PortMap and PortSizeMap should have the same keys")) : ((bStart_3 = (matchValue_11[0] | 0), (bEnd_3 = (matchValue_11[1] | 0), (matchValue_12 = getPrimaryRange(lhs_2, paramMap), (matchValue_12 == null) ? localErrors_2 : ((lhsStart = (matchValue_12[0] | 0), (lhsEnd = (matchValue_12[1] | 0), ((bStart_3 >= lhsStart) && (bEnd_3 <= lhsEnd)) ? localErrors_2 : ((definition = ((bStart_3 === bEnd_3) ? " a single bit " : toText(printf(" %s[%i:0] "))(lhsName_1)(bStart_3)), (patternInput = ((lhsStart === lhsEnd) ? [toText(printf(" %s[%i] "))(lhsName_1)(lhsStart), toText(printf("Out of bounds index for variable \'%s\'"))(lhsName_1)] : [toText(printf(" %s[%i:%i] "))(lhsName_1)(lhsStart)(lhsEnd), toText(printf("Out of bounds range for variable \'%s\'"))(lhsName_1)]), append(localErrors_2, createErrorMessage(linesLocations, lhsLoc_1, patternInput[1], [new ExtraErrorInfo((((toText(printf("Variable: \'%s\' is defined as"))(lhsName_1) + definition) + "\nTherefore,") + patternInput[0]) + "is invalid", false, ReplaceType.NoReplace), new ExtraErrorInfo(toText(printf("assign %s = 0;"))(lhsName_1), true, ReplaceType.Assignment)], lhsName_1))))))))))))))) : ((tryFind((wire_1) => (wire_1 === lhsName_1), getCurrentInputWireList(lhsLoc_1)) != null) ? errorList : append(localErrors_2, createErrorMessage(linesLocations, lhsLoc_1, toText(printf("Variable \'%s\' is not declared as an output port"))(lhsName_1), append_1([new ExtraErrorInfo(toText(printf("Variable \'%s\' is not declared as an output port"))(lhsName_1), false, ReplaceType.NoReplace)], (ast.Module.Type === "module_new") ? [] : [new ExtraErrorInfo(toText(printf("output bit %s;"))(lhsName_1), true, ReplaceType.IODeclaration)]), lhsName_1)))) : ((tryFind((wire_1) => (wire_1 === lhsName_1), getCurrentInputWireList(lhsLoc_1)) != null) ? errorList : append(localErrors_2, createErrorMessage(linesLocations, lhsLoc_1, toText(printf("Variable \'%s\' is not declared as an output port"))(lhsName_1), append_1([new ExtraErrorInfo(toText(printf("Variable \'%s\' is not declared as an output port"))(lhsName_1), false, ReplaceType.NoReplace)], (ast.Module.Type === "module_new") ? [] : [new ExtraErrorInfo(toText(printf("output bit %s;"))(lhsName_1), true, ReplaceType.IODeclaration)]), lhsName_1)))))))))), (matchValue_23 = assignment_2.LHS.VariableBitSelect, (matchValue_23 != null) ? checkNamesOnRHSOfAssignment(matchValue_23, currentInputWireList_3, errlst) : errlst)), assignment_2.RHS);
        const matchValue_24 = assignment_2.LHS.VariableBitSelect;
        if (matchValue_24 != null) {
            return checkExpr(linesLocations, currentInputWireSizeMap_2, arraySizeMap, paramMap, errlst_1, matchValue_24);
        }
        else {
            return errlst_1;
        }
    }, assignmentsWithLocation)));
    const exprErrors = collect((tupledArg_2) => checkNamesOnRHSOfAssignment(tupledArg_2[0], getCurrentInputWireList(tupledArg_2[1]), empty()), foldAST(getCondAndCaseExpressions, empty(), new ASTNode(/* VerilogInput */ 21, [ast])));
    return append(errorList, append(localErrors_6, append(collect((decl_3) => {
        const decl_1 = decl_3;
        const localErrors_1 = empty();
        return fold_1((errorList_1, lhs_1) => {
            const matchValue_4 = tryFind_1(lhs_1.Name, portMap);
            if (matchValue_4 != null) {
                const portTypeS_1 = getPortTypesString(matchValue_4);
                return append(errorList_1, createErrorMessage(linesLocations, lhs_1.Location, toText(printf("Variable \'%s\' is already used by a port or variable"))(lhs_1.Name), [new ExtraErrorInfo(toText(printf("Variable \'%s\' is declared as an %s port\nPlease use a different name for this variable"))(lhs_1.Name)(portTypeS_1), false, ReplaceType.NoReplace)], lhs_1.Name));
            }
            else {
                const matchValue_5 = tryFind((x_2) => (x_2 === lhs_1.Name), notUniqeWireNames);
                if (matchValue_5 != null) {
                    return createErrorMessage(linesLocations, lhs_1.Location, toText(printf("Variable \'%s\' is already used by another wire"))(lhs_1.Name), [new ExtraErrorInfo(toText(printf("Variable \'%s\' is already used by another wire\nPlease use a different name for this wire"))(lhs_1.Name), false, ReplaceType.NoReplace)], lhs_1.Name);
                }
                else if (decl_1.Range == null) {
                    return localErrors_1;
                }
                else {
                    let bStart_1;
                    try {
                        bStart_1 = evalExprWithParams(value_2(decl_1.Range).Start, paramMap);
                    }
                    catch (matchValue_7) {
                        bStart_1 = undefined;
                    }
                    let bEnd_1;
                    try {
                        bEnd_1 = evalExprWithParams(value_2(decl_1.Range).End, paramMap);
                    }
                    catch (matchValue_8) {
                        bEnd_1 = undefined;
                    }
                    let matchResult, bEnd_2, bStart_2;
                    if (bStart_1 != null) {
                        if (bEnd_1 != null) {
                            matchResult = 1;
                            bEnd_2 = bEnd_1;
                            bStart_2 = bStart_1;
                        }
                        else {
                            matchResult = 0;
                        }
                    }
                    else {
                        matchResult = 0;
                    }
                    switch (matchResult) {
                        case 0:
                            return createErrorMessage(linesLocations, lhs_1.Location, "Width declaration must evaluate to constant", [new ExtraErrorInfo(toText(printf("A width must be compile-time constant. Did you mispell a parameter?")), false, ReplaceType.NoReplace)], lhs_1.Name);
                        default:
                            if ((bEnd_2 !== 0) ? true : (bStart_2 <= bEnd_2)) {
                                return createErrorMessage(linesLocations, lhs_1.Location, "Wrong width declaration", [new ExtraErrorInfo(toText(printf("A port\'s width can\'t be \'[%i:%i]\'\nCorrect form: [X:0]"))(bStart_2)(bEnd_2), false, ReplaceType.NoReplace)], lhs_1.Name);
                            }
                            else {
                                return localErrors_1;
                            }
                    }
                }
            }
        }, localErrors_1, decl_1.Variables);
    }, foldAST(getDeclarations, empty(), new ASTNode(/* VerilogInput */ 21, [ast]))), exprErrors)));
}

export function checkUnsupportedKeywords(ast, linesLocations, errorList) {
    return append(errorList, collect((tupledArg) => {
        const tp = tupledArg[0];
        const message = (tp === "NO-COMB") ? "Non-Combinational logic is not supported" : ((tp === "NO-CASE") ? "Case statement is not supported" : ((tp === "WIRE-DECL") ? "Assign directly a value to the wire \n \'wire {name} = {value};\'" : "Non-Combinational logic is not supported"));
        return createErrorMessage(linesLocations, tupledArg[2], message, [new ExtraErrorInfo(message, false, ReplaceType.NoReplace)], tupledArg[1]);
    }, map_2((item_1) => [item_1.Type, item_1.ItemType, item_1.Location], filter_1((item) => {
        if ((item.Type === "NO-COMB") ? true : (item.Type === "NO-CASE")) {
            return true;
        }
        else {
            return item.Type === "WIRE-DECL";
        }
    }, ofArray(ast.Module.ModuleItems.ItemList)))));
}

/**
 * Checks if the RHS expression is wider than the LHS of an assignment.
 * Checks every assignment: continuous and combinational
 */
export function checkAssignmentWidths(ast, linesLocations, portSizeMap, wireSizeMap, arraySizeMap, paramMap, errorList) {
    const wireAndPortSizeMap = fold_2((acc, key, value) => add(key, value, acc), wireSizeMap, portSizeMap);
    return append(errorList, collect((tupledArg) => {
        const assign = tupledArg[0];
        const rhsW = getWidthOfExpr(assign.RHS, wireAndPortSizeMap, arraySizeMap, paramMap) | 0;
        const lhsW = getLHSWidth(assign, wireAndPortSizeMap, arraySizeMap) | 0;
        if (rhsW > lhsW) {
            const message = toText(printf("The RHS expression (%A bits wide) doesn\'t fit in the variable on the LHS (%A bits wide)"))(rhsW)(lhsW);
            return createErrorMessage(linesLocations, tupledArg[1], message, [new ExtraErrorInfo(message, false, ReplaceType.NoReplace)], lhsName_2(assign.LHS));
        }
        else {
            return empty();
        }
    }, foldAST(getAssignmentsWithLocations, empty(), new ASTNode(/* VerilogInput */ 21, [ast]))));
}

export function checkInputsAssigned(ast, linesLocations, portMap, errorInfoList) {
    return append(errorInfoList, collect((assign) => {
        const matchValue = tryFind_1(lhsName_2(assign.LHS), portMap);
        let matchResult;
        if (matchValue != null) {
            if (matchValue.tag === 0) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                let message;
                const arg = lhsName_2(assign.LHS);
                message = toText(printf("Cannot assign to input port \'%s\'"))(arg);
                const extraMessages = [new ExtraErrorInfo(message, false, ReplaceType.NoReplace)];
                return createErrorMessage(linesLocations, lhsLocation(assign.LHS), message, extraMessages, lhsName_2(assign.LHS));
            }
            default:
                return empty();
        }
    }, foldAST(getAssignments$0027, empty(), new ASTNode(/* VerilogInput */ 21, [ast]))));
}

export function getNotUniquePortDeclarations(items) {
    return map_2((tuple) => tuple[0], filter_1((tupledArg) => (tupledArg[1] > 1), List_countBy((x_2) => x_2, collect((x) => {
        if (x.tag === 0) {
            return collect((x_1) => singleton(x_1.Name), ofArray(x.fields[0].Variables));
        }
        else {
            return empty();
        }
    }, items), {
        Equals: (x_3, y) => (x_3 === y),
        GetHashCode: (x_3) => (stringHash(x_3) | 0),
    })));
}

/**
 * Returns the port-size map (e.g. (port "a" => 4 bits wide))
 */
export function getPortSizeAndLocationMap(items, paramMap) {
    const portSizeLocation = collect((x) => {
        if (x.tag === 0) {
            const ioItem = x.fields[0];
            let size;
            if (ioItem.Range == null) {
                size = 1;
            }
            else {
                try {
                    size = ((evalExprWithParams(value_2(ioItem.Range).Start, paramMap) - evalExprWithParams(value_2(ioItem.Range).End, paramMap)) + 1);
                }
                catch (matchValue_1) {
                    size = -1;
                }
            }
            return collect((identifier) => singleton([identifier.Name, size, identifier.Location]), ofArray(ioItem.Variables));
        }
        else {
            return empty();
        }
    }, items);
    const ps = map_2((x_1) => [x_1[0], x_1[1]], portSizeLocation);
    const pl = map_2((x_2) => [x_2[0], x_2[2]], portSizeLocation);
    return [ofList(ps, {
        Compare: (x_3, y) => (comparePrimitives(x_3, y) | 0),
    }), ofList(pl, {
        Compare: (x_4, y_1) => (comparePrimitives(x_4, y_1) | 0),
    })];
}

/**
 * Returns the port-width declaration map (e.g. (  port "a" => (4,0)  ))
 */
export function getPortWidthDeclarationMap(items, paramMap) {
    return ofList(collect((x) => {
        if (x.tag === 0) {
            const d = x.fields[0];
            let size;
            if (d.Range == null) {
                size = [0, 0];
            }
            else {
                try {
                    size = [evalExprWithParams(value_2(d.Range).Start, paramMap), evalExprWithParams(value_2(d.Range).End, paramMap)];
                }
                catch (matchValue_1) {
                    size = [-1, -1];
                }
            }
            return collect((x_1) => singleton([x_1.Name, size]), ofArray(d.Variables));
        }
        else {
            return empty();
        }
    }, items), {
        Compare: (x_2, y) => (comparePrimitives(x_2, y) | 0),
    });
}

/**
 * Returns the port-type map (e.g. (port "a" => INPUT))
 */
export function getPortMap(items) {
    return ofList(collect((x) => {
        if (x.tag === 0) {
            const ioItem = x.fields[0];
            return collect((identifier) => singleton([identifier.Name, ioItem.DeclarationType]), ofArray(ioItem.Variables));
        }
        else {
            return empty();
        }
    }, items), {
        Compare: (x_1, y) => (comparePrimitives(x_1, y) | 0),
    });
}

export function getInputSizeMap(inputNameList, portSizeMap) {
    return filter((n, s) => exists_1((x) => equals(x, n), inputNameList), portSizeMap);
}

/**
 * Returns the names of the ports declared as INPUT
 */
export function getInputNames(portMap) {
    return map_2((tuple) => tuple[0], toList(filter((n, s) => equals(s, DeclarationDU.InputDecl), portMap)));
}

export function getArraySizeMap(items, paramMap) {
    return ofList(collect((x) => {
        if (x.tag === 2) {
            const decl = x.fields[0];
            return collect((var$) => {
                if (decl.DeclarationType.tag === 2) {
                    const matchValue_1 = decl.ArrayRanges;
                    if (matchValue_1 == null) {
                        return empty();
                    }
                    else {
                        const arrayRanges = matchValue_1;
                        return singleton([var$.Name, [(decl.Range == null) ? 1 : ((evalExprWithParams(value_2(decl.Range).Start, paramMap) - evalExprWithParams(value_2(decl.Range).End, paramMap)) + 1), map_4((range) => (((evalExprWithParams(range.Start, paramMap) - evalExprWithParams(range.End, paramMap)) + 1) | 0), arrayRanges, Int32Array)]]);
                    }
                }
                else {
                    return empty();
                }
            }, ofArray(decl.Variables));
        }
        else {
            return empty();
        }
    }, items), {
        Compare: (x_1, y) => (comparePrimitives(x_1, y) | 0),
    });
}

export function getWireNames(items) {
    return collect((x) => {
        if (x.tag === 3) {
            const cont = x.fields[0];
            if (cont.StatementType.tag === 1) {
                return singleton(getPrimaryName(cont.Assignment.LHS.PrimaryType));
            }
            else {
                return empty();
            }
        }
        else {
            return empty();
        }
    }, items);
}

export function getWireLocationMap(items) {
    return ofList(collect((x) => {
        if (x.tag === 3) {
            const cont = x.fields[0];
            if (cont.StatementType.tag === 1) {
                return singleton([getPrimaryName(cont.Assignment.LHS.PrimaryType), cont.Location]);
            }
            else {
                return empty();
            }
        }
        else {
            return empty();
        }
    }, items), {
        Compare: (x_1, y) => (comparePrimitives(x_1, y) | 0),
    });
}

export function getParamMap(ast, linesLocations, items) {
    const paramDeclsList = collect((_arg_1) => {
        if (_arg_1.tag === 1) {
            return ofArray(_arg_1.fields[0].Parameters);
        }
        else {
            return empty();
        }
    }, filter_1((_arg) => {
        if (_arg.tag === 1) {
            return true;
        }
        else {
            return false;
        }
    }, items));
    const patternInput = fold((tupledArg, param) => {
        const paramMap = tupledArg[0];
        const errors = tupledArg[1];
        const paramName = param.Identifier.Name;
        const paramLoc = param.Identifier.Location | 0;
        let duplicateParamErrors;
        const matchValue = tryFind_1(paramName, paramMap);
        if (matchValue == null) {
            duplicateParamErrors = empty();
        }
        else {
            duplicateParamErrors = createErrorMessage(linesLocations, paramLoc, toText(printf("Identifier \'%s\' is already used by another parameter"))(paramName), [new ExtraErrorInfo(toText(printf("Identifier \'%s\' is already used by another parameter\nPlease use a different name for this parameter"))(paramName), false, ReplaceType.NoReplace)], paramName);
        }
        try {
            return [add(paramName, evalExprWithParams(param.RHS, paramMap), paramMap), append(duplicateParamErrors, errors)];
        }
        catch (matchValue_1) {
            const extraMessages_1 = [new ExtraErrorInfo(toText(printf("Parameter \'%s\' cannot be evaluated to a constant"))(paramName), false, ReplaceType.NoReplace)];
            return [paramMap, append(createErrorMessage(linesLocations, paramLoc, toText(printf("Wrong parameter declaration")), extraMessages_1, paramName), append(duplicateParamErrors, errors))];
        }
    }, [empty_1({
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }), empty()], paramDeclsList);
    return [patternInput[0], reverse(patternInput[1])];
}

/**
 * Helper error-finder function
 * Called again in module instantations after parameters are evaluated to ensure overriding works
 * Returns a list of errors (type ErrorInfo)
 */
export function getSemanticErrorsNoParamOverride(ast, linesLocations, paramMap, origin, project) {
    const items = map_2(convertItem, ofArray(ast.Module.ModuleItems.ItemList));
    const portMap = getPortMap(items);
    const patternInput = getPortSizeAndLocationMap(items, paramMap);
    const portSizeMap = patternInput[0];
    const portWidthDeclarationMap = getPortWidthDeclarationMap(items, paramMap);
    getNotUniquePortDeclarations(items);
    const inputNameList = getInputNames(portMap);
    const wireSizeMap = getWireSizeMap(items, paramMap);
    const arraySizeMap = getArraySizeMap(items, paramMap);
    const loopErr = checkForLoopUnrollCost(ast, paramMap, linesLocations, empty());
    if (!isEmpty_1(loopErr)) {
        return loopErr;
    }
    else {
        const declarations_1 = foldAST(getDeclarations, empty(), new ASTNode(/* VerilogInput */ 21, [ast]));
        const wireSizeMap_1 = fold((map, decl) => fold_1((map$0027, variable) => {
            if (decl.Range == null) {
                return add(variable.Name, 1, map$0027);
            }
            else {
                return add(variable.Name, (evalExprWithParams(value_2(decl.Range).Start, paramMap) - evalExprWithParams(value_2(decl.Range).End, paramMap)) + 1, map$0027);
            }
        }, map, decl.Variables), wireSizeMap, declarations_1);
        return List_distinct(checkInputsAssigned(ast, linesLocations, portMap, checkModuleInstantiations(ast, linesLocations, portSizeMap, paramMap, items, project, portMap, checkAssignmentWidths(ast, linesLocations, portSizeMap, wireSizeMap_1, arraySizeMap, paramMap, checkAlwaysCombRHS(ast, linesLocations, portSizeMap, wireSizeMap_1, checkVariablesUsed(ast, linesLocations, portSizeMap, wireSizeMap_1, paramMap, arraySizeMap, cycleCheck(ast, linesLocations, portSizeMap, wireSizeMap_1, checkClkNames(ast, linesLocations, portMap, patternInput[1], portSizeMap, checkClk(ast, linesLocations, portMap, checkExpressions(ast, linesLocations, wireSizeMap_1, arraySizeMap, paramMap, checkCasesStatements(ast, linesLocations, portSizeMap, wireSizeMap_1, arraySizeMap, paramMap, checkArrayStatements(ast, linesLocations, arraySizeMap, checkVariablesAlwaysAssigned(ast, linesLocations, portSizeMap, wireSizeMap_1, arraySizeMap, paramMap, checkVariablesDrivenSimultaneously(ast, linesLocations, arraySizeMap, checkForLoopVar(ast, linesLocations, checkProceduralAssignments(ast, linesLocations, checkUnsupportedKeywords(ast, linesLocations, checkAllOutputsAssigned(ast, portMap, portSizeMap, paramMap, linesLocations, checkWiresAndAssignments(ast, portMap, portSizeMap, portWidthDeclarationMap, inputNameList, linesLocations, getWireNames(items), wireSizeMap_1, fold((wireLocMap, decl_1) => fold_1((map_1, var$) => add(var$.Name, var$.Location, map_1), wireLocMap, decl_1.Variables), getWireLocationMap(items), declarations_1), arraySizeMap, paramMap, checkIOWidthDeclarations(ast, paramMap, linesLocations, empty()))))))))))))))))))), {
            Equals: equals,
            GetHashCode: (x) => (safeHash(x) | 0),
        });
    }
}

export function getExtraParamErrors(ast, wireSizeMap, portSizeMap, linesLocations, origin, project, modInst, comp) {
    let matchValue_2, matchValue_3;
    const wireAndPortSizeMap = fold_2((acc, key, value) => add(key, value, acc), wireSizeMap, portSizeMap);
    let parsedAST;
    const matchValue = comp.Form;
    let matchResult, name;
    if (matchValue != null) {
        if (matchValue.tag === 4) {
            matchResult = 0;
            name = matchValue.fields[0];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            let code;
            const matchValue_1 = tryReadFileSync(pathJoin([project.ProjectPath, name + ".v"]));
            code = ((matchValue_1.tag === 1) ? toText(printf("Error: file {%s.v} has been deleted from the project directory"))(name) : matchValue_1.fields[0]);
            const result = value_2(((matchValue_2 = SimpleJson_tryParse(parseFromFile(code)), (matchValue_2 != null) ? Convert_fromJson(matchValue_2, createTypeInfo(ParserOutput_$reflection())) : (() => {
                throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
            })())).Result);
            parsedAST = ((matchValue_3 = SimpleJson_tryParse(fix(result)), (matchValue_3 != null) ? Convert_fromJson(matchValue_3, createTypeInfo(VerilogInput_$reflection())) : (() => {
                throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
            })()));
            break;
        }
        default:
            parsedAST = undefined;
    }
    const matchValue_4 = modInst.Parameters;
    if (matchValue_4 == null) {
        const matchValue_6 = filter_1((comp_1) => (comp_1.Name === modInst.Module.Name), project.LoadedComponents);
        if (!isEmpty_1(matchValue_6)) {
            if (isEmpty_1(tail(matchValue_6))) {
                return collect((conn_1) => {
                    const matchValue_7 = tryFind((port$0027_1) => (port$0027_1[0] === conn_1.PortId.Name.toLocaleUpperCase()), append(head(matchValue_6).InputLabels, head(matchValue_6).OutputLabels));
                    if (matchValue_7 != null) {
                        const port_1 = matchValue_7;
                        const w_1 = getPrimaryWidth(wireAndPortSizeMap, conn_1.Primary) | 0;
                        if (port_1[1] !== w_1) {
                            const extraMessages_2 = [new ExtraErrorInfo(toText(printf("Wrong port width for port %A in module %A: %A bits wide but expected %A bits"))(conn_1.PortId.Name)(modInst.Module.Name)(w_1)(port_1[1]), false, ReplaceType.NoReplace)];
                            const message_2 = toText(printf("Wrong port width"));
                            return createErrorMessage(linesLocations, getPrimaryLocation(conn_1.Primary), message_2, extraMessages_2, getPrimaryName(conn_1.Primary));
                        }
                        else {
                            return empty();
                        }
                    }
                    else {
                        return empty();
                    }
                }, ofArray(modInst.Connections));
            }
            else {
                return toFail(printf("There are multiple custom components with this name!"));
            }
        }
        else {
            return empty();
        }
    }
    else {
        const parameters = matchValue_4;
        const givenParams = ofArray_1(map_4((param) => param.Identifier.Name, parameters), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        });
        const overrideMap = fold_1((map, param_1) => add(param_1.Identifier.Name, evalExpr(param_1.Value), map), empty_1({
            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
        }), parameters);
        if (parsedAST != null) {
            const parsedAST_1 = parsedAST;
            const expectedParams = ofList_1(map_2((param_2) => param_2.Identifier.Name, foldAST(getParamDeclarations, empty(), new ASTNode(/* VerilogInput */ 21, [parsedAST_1]))), {
                Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
            });
            const overrideMap_1 = fold_2((map_1, key_1, value_1) => {
                if (containsKey(key_1, overrideMap)) {
                    return map_1;
                }
                else {
                    return add(key_1, value_1, map_1);
                }
            }, overrideMap, ofList(map_2((param_3) => [param_3.Identifier.Name, evalExpr(param_3.RHS)], foldAST(getParamDeclarations, empty(), new ASTNode(/* VerilogInput */ 21, [parsedAST_1]))), {
                Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
            }));
            const extraParams = difference(givenParams, expectedParams);
            const extraParamErrors = collect((param_4) => {
                if (contains_1(param_4.Identifier.Name, extraParams)) {
                    const extraMessages = [new ExtraErrorInfo(toText(printf("The parameter %A does not exist for component %A"))(param_4.Identifier.Name)(comp.Name), false, ReplaceType.NoReplace)];
                    return createErrorMessage(linesLocations, param_4.Identifier.Location, toText(printf("No such parameter for the given component")), extraMessages, param_4.Identifier.Name);
                }
                else {
                    return empty();
                }
            }, ofArray(parameters));
            let portWidthErrors;
            const portMap = getPortSizeAndLocationMap(map_2(convertItem, ofArray(parsedAST_1.Module.ModuleItems.ItemList)), overrideMap_1);
            portWidthErrors = collect((conn) => {
                const matchValue_5 = tryFind((port$0027) => (port$0027[0] === conn.PortId.Name.toLocaleUpperCase()), toList(portMap[0]));
                if (matchValue_5 != null) {
                    const port = matchValue_5;
                    const w = getPrimaryWidth(wireAndPortSizeMap, conn.Primary) | 0;
                    if (port[1] !== w) {
                        const extraMessages_1 = [new ExtraErrorInfo(toText(printf("Wrong port width for port %A in module %A: %A bits wide but expected %A bits"))(conn.PortId.Name)(modInst.Module.Name)(w)(port[1]), false, ReplaceType.NoReplace)];
                        const message_1 = toText(printf("Wrong port width"));
                        return createErrorMessage(linesLocations, getPrimaryLocation(conn.Primary), message_1, extraMessages_1, getPrimaryName(conn.Primary));
                    }
                    else {
                        return empty();
                    }
                }
                else {
                    return empty();
                }
            }, ofArray(modInst.Connections));
            return append(extraParamErrors, append(getSemanticErrorsNoParamOverride(parsedAST_1, linesLocations, overrideMap_1, origin, project), portWidthErrors));
        }
        else {
            return empty();
        }
    }
}

export function getSemanticErrors(ast, linesLocations, origin, project) {
    const items = map_2(convertItem, ofArray(ast.Module.ModuleItems.ItemList));
    const patternInput = getParamMap(ast, linesLocations, items);
    const paramMap = patternInput[0];
    const paramDeclErrors = patternInput[1];
    if (isEmpty_1(paramDeclErrors) === false) {
        return paramDeclErrors;
    }
    else {
        const portMap = getPortMap(items);
        const patternInput_1 = getPortSizeAndLocationMap(items, paramMap);
        const wireSizeMap = getWireSizeMap(items, paramMap);
        const portWidthDeclarationMap = getPortWidthDeclarationMap(items, paramMap);
        const notUniquePortDeclarations = getNotUniquePortDeclarations(items);
        getInputNames(portMap);
        const forLoopErrorsBeforeUnroll = checkForLoopUnrollCost(ast, paramMap, linesLocations, empty());
        if (isEmpty_1(forLoopErrorsBeforeUnroll)) {
            const moduleInstantiations_1 = foldAST(getModuleInstantiationStatements, empty(), new ASTNode(/* VerilogInput */ 21, [ast]));
            return append(collect((modInst) => {
                const matchValue_1 = filter_1((comp) => (comp.Name === modInst.Module.Name), project.LoadedComponents);
                if (!isEmpty_1(matchValue_1)) {
                    if (isEmpty_1(tail(matchValue_1))) {
                        const extraParamErrors = getExtraParamErrors(ast, wireSizeMap, patternInput_1[0], linesLocations, origin, project, modInst, head(matchValue_1));
                        const matchValue_2 = isEmpty_1(extraParamErrors);
                        if (matchValue_2) {
                            return empty();
                        }
                        else {
                            const extraMessages = [new ExtraErrorInfo(toText(printf("The overriden parameters instantiated with component %A are not compatible. Please see errors below and fix accordingly."))(modInst.Module.Name), false, ReplaceType.NoReplace)];
                            return append(createErrorMessage(linesLocations, modInst.Identifier.Location, toText(printf("Parameter override value cannot be used for this module")), extraMessages, modInst.Module.Name), extraParamErrors);
                        }
                    }
                    else {
                        return toFail(printf("There are multiple custom components with this name!"));
                    }
                }
                else {
                    return empty();
                }
            }, moduleInstantiations_1), append(checkParamsUsed(ast, linesLocations, paramMap, checkIODeclarations(ast, portWidthDeclarationMap, patternInput_1[1], linesLocations, notUniquePortDeclarations, portMap, project, checkForLoopUnrollCost(ast, paramMap, linesLocations, portCheck(ast, linesLocations, nameCheck(ast, linesLocations, origin, project, isEmpty_1(moduleInstantiations_1) ? empty() : forLoopErrorsBeforeUnroll))))), getSemanticErrorsNoParamOverride(ast, linesLocations, paramMap, origin, project)));
        }
        else {
            return forLoopErrorsBeforeUnroll;
        }
    }
}

